import type { ApiClient } from '../client';
import { LocationCarriersResponseSchema } from '../schemas/locationCarriers';
import type { CarrierOption } from '../schemas/carriers';

// The carriers that have delivered at one building — the only source of the carrier filter's
// options, which is what makes an option that matches nothing structurally impossible.
//
// The location id rides the PATH as a number, so there is nothing in it to escape and no query
// string to build; the client attaches the Firebase token via the Authorization header.
//
// Returns the BARE entries rather than the envelope, exactly as the address search does: the read
// neither caps nor paginates, so `count` and the list's length are equal by contract, and offering
// two ways to read one number is how a select ends up disagreeing with itself. A cursor fails the
// parse upstream in the schema — the panel must not render a partial list of options.
export async function fetchLocationCarriers(
  client: ApiClient,
  locationId: number,
): Promise<CarrierOption[]> {
  const data = await client.get<unknown>(
    `/app_service/panel/v1/locations/${String(locationId)}/carriers`,
  );
  return LocationCarriersResponseSchema.parse(data).results;
}
